import type { IconNode } from '../types';

/**
 * @name smartphone-user-round
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJINmEyIDIgMCAwMS0yLTJWNGEyIDIgMCAwMTItMmgxMGEyIDIgMCAwMTIgMnY0IiAvPgogIDxwYXRoIGQ9Ik0xMSAxOGguMDEiIC8+CiAgPHBhdGggZD0iTTIyIDIyYTQgNCAwIDAwLTggMCIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE1IiByPSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/smartphone-user-round
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SmartphoneUserRound: IconNode = [
  ['path', { d: 'M10 22H6a2 2 0 01-2-2V4a2 2 0 012-2h10a2 2 0 012 2v4' }],
  ['path', { d: 'M11 18h.01' }],
  ['path', { d: 'M22 22a4 4 0 00-8 0' }],
  ['circle', { cx: '18', cy: '15', r: '3' }],
];

export default SmartphoneUserRound;
